<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link
          to="/Dashboard"
          name="Dashboard"
          icon="ti-dashboard"
          class="d"
        />

        <!-- GROUP 1: ANALYTICS -->
        <div class="d">
          <drop-down
            title="ANALYTICS & REPORTING "
            icon=""
            :image="require('@/assets/img/analytics.png')"
            class="trans-dropdown reduce"
            :is-open="openDropdown === 'analytics'"
            @change="handleToggle('analytics')"
          >
            <div
              class="e"
              style="color: #dfdede; background-color: #333f48; font-size: 12px"
            >
              <guard
                requiredPermission="agent"
                requiredAction="read"
                :style="{ display: isInstitution ? 'none' : 'block' }"
              >
                <sidebar-link
                  to="/dashboard/accounts"
                  name="Accounts"
                  class="dropdown-link"
                />
              </guard>

              <guard requiredPermission="agent" requiredAction="read">
                <sidebar-link
                  to="/dashboard/analytics-terminals"
                  name="Terminals"
                  class="dropdown-link"
                />
              </guard>

              <guard requiredPermission="purchase" requiredAction="read">
                <sidebar-link
                  to="/dashboard/analytics-transactions"
                  name="Transactions"
                  class="dropdown-link"
                />
              </guard>
            </div>
          </drop-down>
        </div>

        <guard class="d" requiredPermission="provider" requiredAction="read">
          <sidebar-link
            to="/dashboard/providers"
            name="Providers"
            icon="ti-cloud"
          />
        </guard>

        <guard class="d" requiredPermission="routing" requiredAction="read">
          <sidebar-link
            to="/dashboard/routing"
            name="Transaction Routing"
            icon="ti-angle-up"
          />
        </guard>

        <guard class="d" requiredPermission="limits" requiredAction="read">
          <sidebar-link
            to="/dashboard/transaction-limits"
            name="Transaction Limits"
            icon="ti-lock"
          />
        </guard>

        <!-- GROUP 2: WALLET -->
        <div class="d" :style="{ display: isInstitution ? 'none' : 'block' }">
          <drop-down
            title="Wallet"
            icon="ti-wallet"
            class="trans-dropdown reduce"
            :is-open="openDropdown === 'wallet'"
            @change="handleToggle('wallet')"
          >
            <div class="e">
              <guard requiredPermission="funding" requiredAction="read">
                <sidebar-link
                  to="/dashboard/wallet-funding"
                  name="Wallet Funding"
                  class="dropdown-link"
                />
              </guard>
              <guard requiredPermission="walletReport" requiredAction="read">
                <sidebar-link
                  to="/dashboard/wallet-reports"
                  name="Wallet Reports"
                  class="dropdown-link"
                />
              </guard>
            </div>
          </drop-down>
        </div>

        <guard class="d" requiredPermission="logs" requiredAction="read">
          <sidebar-link
            to="/dashboard/activity-logs"
            name="Activity Logs"
            icon="ti-list"
          />
        </guard>

        <!-- GROUP 3: AGENCY BANKING -->
        <div class="d">
          <drop-down
            title="Agency Banking"
            icon="ti-user"
            class="trans-dropdown"
            :is-open="openDropdown === 'agency_banking'"
            @change="handleToggle('agency_banking')"
          >
            <div
              class="e"
              style="color: #dfdede; background-color: #333f48; font-size: 12px"
            >
              <guard
                requiredPermission="agent"
                requiredAction="read"
                :style="{ display: isInstitution ? 'none' : 'block' }"
              >
                <sidebar-link
                  to="/dashboard/all-agents"
                  name="Agents"
                  class="dropdown-link"
                />
              </guard>

              <guard requiredPermission="merchantAgent" requiredAction="read">
                <sidebar-link
                  to="/dashboard/merchants"
                  name="Agent Category"
                  class="dropdown-link"
                />
              </guard>

              <drop-down
                title="Agents KYC"
                class="trans-dropdown m-0"
                :is-open="openNestedDropdown === 'agents'"
                @change="handleToggleNested('agents')"
                :style="{ display: isInstitution ? 'none' : 'block' }"
              >
                <div class="e">
                  <guard requiredPermission="agent" requiredAction="read">
                    <sidebar-link
                      to="/dashboard/agent-All-Account"
                      name="All Accounts"
                      class="dropdown-link"
                    />
                  </guard>
                  <guard requiredPermission="agent" requiredAction="read">
                    <sidebar-link
                      to="/dashboard/agent-Individual-Account"
                      name="Individual Account"
                      class="dropdown-link"
                    />
                  </guard>
                  <guard requiredPermission="agent" requiredAction="read">
                    <sidebar-link
                      to="/dashboard/agent-business-account"
                      name="Business Account"
                      class="dropdown-link"
                    />
                  </guard>
                </div>
              </drop-down>

              <guard
                class="d"
                requiredPermission="configuration"
                requiredAction="read"
              >
                <sidebar-link
                  to="/dashboard/terminals"
                  name="Terminals"
                  class="dropdown-link"
                />
              </guard>

              <drop-down
                title="Transactions"
                class="trans-dropdown"
                :is-open="openNestedDropdown === 'agency_banking_transactions'"
                @change="handleToggleNested('agency_banking_transactions')"
              >
                <div class="e">
                  <guard requiredPermission="transaction" requiredAction="read">
                    <sidebar-link
                      to="/dashboard/transactions"
                      name="Withdrawals"
                      class="dropdown-link"
                    />
                  </guard>
                  <guard
                    requiredPermission="transaction"
                    requiredAction="read"
                    :style="{ display: isInstitution ? 'none' : 'block' }"
                  >
                    <sidebar-link
                      to="/dashboard/vas-transactions"
                      name="Vas Transactions"
                      class="dropdown-link"
                    />
                  </guard>
                  <guard
                    requiredPermission="transaction"
                    requiredAction="read"
                    :style="{ display: isInstitution ? 'none' : 'block' }"
                  >
                    <sidebar-link
                      to="/dashboard/pay-with-transfer"
                      name="Pay With Transfer"
                      class="dropdown-link"
                    />
                  </guard>
                  <guard
                    requiredPermission="charge"
                    requiredAction="read"
                    :style="{ display: isInstitution ? 'none' : 'block' }"
                  >
                    <sidebar-link
                      to="/dashboard/charges"
                      name="Transaction Charges"
                      class="dropdown-link"
                    />
                  </guard>
                  <guard
                    requiredPermission="transactionReport"
                    requiredAction="read"
                    :style="{ display: isInstitution ? 'none' : 'block' }"
                  >
                    <sidebar-link
                      to="/dashboard/get-logs"
                      name="Transaction Logs"
                      class="dropdown-link"
                    />
                  </guard>
                </div>
              </drop-down>
            </div>
          </drop-down>
        </div>

        <!-- GROUP 4: PTSP -->
        <div class="d">
          <drop-down
            title="PTSP "
            icon=""
            :image="require('@/assets/img/ptsp.png')"
            class="trans-dropdown"
            :is-open="openDropdown === 'ptsp'"
            @change="handleToggle('ptsp')"
          >
            <div
              class="e"
              style="color: #dfdede; background-color: #333f48; font-size: 12px"
            >
              <guard requiredPermission="purchase" requiredAction="read">
                <sidebar-link
                  to="/dashboard/ptsp-merchants"
                  name="Merchants"
                  class="dropdown-link"
                />
              </guard>

              <guard requiredPermission="agent" requiredAction="read">
                <sidebar-link
                  to="/dashboard/ptsp-terminals"
                  name="Terminals"
                  class="dropdown-link"
                />
              </guard>

              <drop-down
                title="Transactions"
                class="trans-dropdown"
                :is-open="openNestedDropdown === 'ptsp_transactions'"
                @change="handleToggleNested('ptsp_transactions')"
              >
                <div class="e">
                  <guard requiredPermission="transaction" requiredAction="read">
                    <sidebar-link
                      to="/dashboard/purchases"
                      name="Purchases"
                      class="dropdown-link"
                    />
                  </guard>

                  <guard
                    requiredPermission="transaction"
                    requiredAction="read"
                    :style="{ display: isInstitution ? 'none' : 'block' }"
                  >
                    <sidebar-link
                      to="/dashboard/ptsp-pay-with-transfer"
                      name="Pay With Transfer"
                      class="dropdown-link"
                    />
                  </guard>
                </div>
              </drop-down>
            </div>
          </drop-down>
        </div>

        <!-- GROUP 2: TRANSACTIONS -->
        <!-- <div class="d">
          <drop-down
            title="Transactions"
            icon="ti-exchange-vertical"
            class="trans-dropdown"
            :is-open="openDropdown === 'transactions'"
            @change="handleToggle('transactions')"
          >
            <div class="e">
              <guard requiredPermission="purchase" requiredAction="read">
                <sidebar-link
                  to="/dashboard/purchases"
                  name="Purchases"
                  class="dropdown-link"
                />
              </guard>

              <guard requiredPermission="transaction" requiredAction="read">
                <sidebar-link
                  to="/dashboard/transactions"
                  name="Withdrawals"
                  class="dropdown-link"
                />
              </guard>
              <guard
                requiredPermission="transaction"
                requiredAction="read"
                :style="{ display: isInstitution ? 'none' : 'block' }"
              >
                <sidebar-link
                  to="/dashboard/vas-transactions"
                  name="Vas Transactions"
                  class="dropdown-link"
                />
              </guard>
              <guard
                requiredPermission="transaction"
                requiredAction="read"
                :style="{ display: isInstitution ? 'none' : 'block' }"
              >
                <sidebar-link
                  to="/dashboard/pay-with-transfer"
                  name="Pay With Transfer"
                  class="dropdown-link"
                />
              </guard>
              <guard
                requiredPermission="charge"
                requiredAction="read"
                :style="{ display: isInstitution ? 'none' : 'block' }"
              >
                <sidebar-link
                  to="/dashboard/charges"
                  name="Transaction Charges"
                  class="dropdown-link"
                />
              </guard>
              <guard
                requiredPermission="transactionReport"
                requiredAction="read"
                :style="{ display: isInstitution ? 'none' : 'block' }"
              >
                <sidebar-link
                  to="/dashboard/get-logs"
                  name="Transaction Logs"
                  class="dropdown-link"
                />
              </guard>
            </div>
          </drop-down>
        </div> -->

        <!-- GROUP 5: USER MANAGEMENT -->
        <div class="d">
          <drop-down
            title="User Management"
            icon="ti-user"
            class="trans-dropdown"
            :is-open="openDropdown === 'user-management'"
            @change="handleToggle('user-management')"
          >
            <div
              class="e"
              style="color: #dfdede; background-color: #333f48; font-size: 12px"
            >
              <!-- <guard requiredPermission="merchant" requiredAction="read">
                <sidebar-link to="/dashboard/merchant-agents" name="Agents" />
              </guard> -->
              <guard
                requiredPermission="institution"
                requiredAction="read"
                :style="{ display: isInstitution ? 'none' : 'block' }"
              >
                <sidebar-link
                  to="/dashboard/institutions"
                  name="Institutions"
                  class="dropdown-link"
                />
              </guard>

              <guard
                requiredPermission="admin"
                requiredAction="read"
                :style="{ display: isInstitution ? 'none' : 'block' }"
              >
                <sidebar-link
                  to="/dashboard/view-users"
                  name="Administrators"
                  class="dropdown-link"
                />
              </guard>
              <guard
                requiredPermission="admin"
                requiredAction="read"
                :style="{ display: isInstitution ? 'none' : 'block' }"
              >
                <sidebar-link
                  to="/dashboard/role-management"
                  name="Roles"
                  class="dropdown-link"
                />
              </guard>
            </div>
          </drop-down>
        </div>
      </template>
      <mobile-menu>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import Dropdown from "@/components/Dropdown.vue";
import guard from "../../components/guard.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
    Dropdown,
    guard,
  },
  data() {
    return {
      openDropdown: null,
      openNestedDropdown: null,
      userType: localStorage.getItem("userType"),
    };
  },
  computed: {
    ...mapState(["auth"]),
    isInstitution() {
      return this.userType === "INSTITUTIONS";
      // return this.userType === 'super-admin';
    },
  },
  methods: {
    handleToggle(dropdown) {
      this.openDropdown = this.openDropdown === dropdown ? null : dropdown;
    },
    handleToggleNested(nestedDropdown) {
      this.openNestedDropdown =
        this.openNestedDropdown === nestedDropdown ? null : nestedDropdown;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  mounted() {
    if (this.auth.user === null) {
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.wrapper {
  font-size: 12px !important;
}

.d {
  color: #dfdede;
  padding-top: 10px;
  width: 100% !important;
}

.d :hover {
  color: #fff;
}

.trans-dropdown {
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  padding: 10px 0;
  margin-left: 25px;
  cursor: pointer;
  /* margin-bottom: -8px; */
}

.reduce {
  margin-bottom: -5px;
}

.dropdown-link {
  margin: 1px 0 !important;
  padding: 0 !important;
  width: 100%;
}

.e {
  width: 100% !important;
  background-color: #333f48;
  display: block;
  gap: 0.1px !important;
  position: absolute;
  margin: 1px 0 0 0 !important;
  text-align: center;
  /* border-left: 1px solid #f1f1f1 !important; */
}

.role-dropdown {
  width: 100% !important;
  background-color: #333f48;
  display: block;
  gap: 0.1px !important;
  position: absolute;
  margin: 1px 0 0 0 !important;
  text-align: center;
}
</style>
